import React from 'react';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import { aerialObsColor, imageObsColor, pointObsColor } from '../viewer/js/data-aligner';
import clsx from 'clsx';
import { EnhancedIconButton } from '../components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    aerialObservationSuccess: {
      color: `#${aerialObsColor.toString(16)}`
    },
    imageObservationSuccess: {
      color: `#${imageObsColor.toString(16)}`
    },
    pointObservationSuccess: {
      color: `#${pointObsColor.toString(16)}`
    },
    warning: {
      color: theme.palette.warning.main
    },
    error: {
      color: theme.palette.error.main
    },
    info: {
      color: theme.palette.info.main
    },
    errorLow: {
      color: theme.palette.success.main
    },
    errorMedium: {
      color: theme.palette.warning.main
    },
    errorHigh: {
      color: theme.palette.error.main
    },
  }),
);

export const PointObservationIcon = (props) => {
  const classes = useStyles();
  return ObservationIcon({...props, color: classes.pointObservationSuccess});
};

export const AerialObservationIcon = (props) => {
  const classes = useStyles();
  return ObservationIcon({...props, color: classes.aerialObservationSuccess});
};

export const ImageObservationIcon = (props) => {
  const classes = useStyles();
  return ObservationIcon({...props, color: classes.imageObservationSuccess});
};

const ObservationIcon = (props) => {
  const {color, selected, clicked, ...other} = props;
  const classes = useStyles();

  let buttonColor;

  if (clicked) {
    buttonColor = classes.info;
  } else if (selected) {
    buttonColor = color;
  } else {
    buttonColor = classes.error;
  }

  return (
    <EnhancedIconButton
      {...other}
    >
      <ControlPointIcon
        classes={{root: buttonColor}}
        fontSize="small"
      />
    </EnhancedIconButton>
  );
};

export const ObservationError = (props) => {
  const {value, lowCutoff, highCutoff} = props;
  const classes = useStyles();
  const isNumber = !isNaN(parseFloat(value));

  if (!isNumber) {
    return <Box>{"N/A"}</Box>;
  }

  return (
    <Box className={clsx("", {
      [classes.errorLow]: (value < lowCutoff),
      [classes.errorMedium]: (value < highCutoff) && (value >= lowCutoff),
      [classes.errorHigh]: (value >= highCutoff)
    })}>
      {value.toFixed(2)}
    </Box>
  );
};